import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Profile from '../views/Profile.vue'
import store from '../store'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  
  //文件上传
    {
    path: '/file-upload',
    name: 'FileUpload',
    component: () => import('@/views/FileUploader.vue'),
    meta: {
      title: '文件上传系统'
    }
  },
  
  // 添加Animate动画制作在线答题在线答题系统路由
  {
    path: '/animate-exam',
    name: 'AnimateExam',
    component: () => import('@/views/ExamPage.vue'),
    meta: {
      title: 'Animate动画制作在线答题'
    }
  },
  
    // 添加三维动画在线答题系统路由
  {
    path: '/swdh-exam',
    name: 'SwdhExam',
    component: () => import('@/views/SwdhExamPage.vue'),
    meta: {
      title: 'Animate动画制作在线答题'
    }
  },
  
//教师考核
  {
    path: '/teacher-evaluation',
    name: 'TeacherEvaluation',
    component: () => import('@/views/TeacherEvaluation.vue'),
    meta: {
      title: '教师考核系统'
    }
  },
  
  // 添加知识图谱路由
  {
  path: '/knowledge-graph',
  name: 'KnowledgeGraph',
  component: () => import('@/views/KnowledgeGraph.vue')
  },

  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/page/software',
    name: 'Software',
    component: () => import('@/views/Software.vue')
  },
  {
    path: '/page/resourse',
    name: 'Resource',
    component: () => import('@/views/Resource.vue')
  },
  {
    path: '/page/byjy',
    name: 'Graduation',
    component: () => import('@/views/Graduation.vue')
  },
  {
    path: '/page/rcbg',
    name: 'Office',
    component: () => import('@/views/Office.vue')
  },
  {
    path: '/page/vr',
    name: 'VR',
    component: () => import('@/views/VR.vue')
  },
  //{
    //path: '/sub-page/:id',
    //name: 'Course',
    //component: () => import('@/views/Course.vue'),
    //props: true
 // }
 {
  path: '/sub-page/dhsm',
  name: 'SubPageDhsm',
  component: () => import('@/views/courses/SubPageDhsm.vue')
},
{
  path: '/sub-page/dhsc',
  name: 'SubPageDhsc',
  component: () => import('@/views/courses/SubPageDhsc.vue')
},

{
  path: '/sub-page/dhzxsjjc',
  name: 'SubPageDhzxsjjc',
  component: () => import('@/views/courses/SubPageDhzxsjjc.vue')
},

{
  path: '/sub-page/dhjb',
  name: 'SubPageDhjb',
  component: () => import('@/views/courses/SubPageDhjb.vue')
},

{
  path: '/sub-page/dhgl',
  name: 'SubPageDhgl',
  component: () => import('@/views/courses/SubPageDhgl.vue')
},
{
  path: '/sub-page/ktds',
  name: 'SubPageKtds',
  component: () => import('@/views/courses/SubPageKtds.vue')
},
{
  path: '/sub-page/dhbj',
  name: 'SubPageDhbj',
  component: () => import('@/views/courses/SubPageDhbj.vue')
},

{
  path: '/sub-page/ydhjc',
  name: 'SubPageYdhjc',
  component: () => import('@/views/courses/SubPageYdhjc.vue')
},

{
  path: '/sub-page/txtx',
  name: 'SubPagePhotoshop',
  component: () => import('@/views/courses/SubPagePhotoshop.vue')
},
{
  path: '/sub-page/illustrator',
  name: 'SubPageIllustrator',
  component: () => import('@/views/courses/SubPageIllustrator.vue')
},

{
  path: '/sub-page/swjmjc',
  name: 'SubPageSwjmjc',
  component: () => import('@/views/courses/SubPageSwjmjc.vue')
},

{
  path: '/sub-page/animate',
  name: 'SubPageAnimate',
  component: () => import('@/views/courses/SubPageAnimate.vue')
},

{
  path: '/sub-page/swjsdhsj',
  name: 'SubPageSwjsdhsj',
  component: () => import('@/views/courses/SubPageSwjsdhsj.vue')
},

{
  path: '/sub-page/yxsj',
  name: 'SubPageYxsj',
  component: () => import('@/views/courses/SubPageYxsj.vue')
},

{
  path: '/sub-page/swhqtx',
  name: 'SubPageSwhqtx',
  component: () => import('@/views/courses/SubPageSwhqtx.vue')
},

{
  path: '/sub-page/yxyqjc',
  name: 'SubPageYxyqjc',
  component: () => import('@/views/courses/SubPageYxyqjc.vue')
},

{
  path: '/sub-page/dhdyjc',
  name: 'SubPageDhdyjc',
  component: () => import('@/views/courses/SubPageDhdyjc.vue')
},

{
  path: '/sub-page/dhstyy',
  name: 'SubPageDhstyy',
  component: () => import('@/views/courses/SubPageDhstyy.vue')
},

{
  path: '/sub-page/ystxzz',
  name: 'SubPageYstxzz',
  component: () => import('@/views/courses/SubPageYstxzz.vue')
},

{
  path: '/sub-page/fxxbj',
  name: 'SubPageFxxbj',
  component: () => import('@/views/courses/SubPageFxxbj.vue')
},

{
  path: '/sub-page/swdh',
  name: 'SubPageSwdh',
  component: () => import('@/views/courses/SubPageSwdh.vue')
},


//第二页课程

{
  path: '/sub-page/dhjtsjjf',
  name: 'SubPageDhjtsjjf',
  component: () => import('@/views/courses/SubPageDhjtsjjf.vue')
},

{
  path: '/sub-page/lw',
  name: 'SubPageLw',
  component: () => import('@/views/courses/SubPageLw.vue')
},

{
  path: '/sub-page/dgdh',
  name: 'SubPageDgdh',
  component: () => import('@/views/courses/SubPageDgdh.vue')
},

{
  path: '/sub-page/spine',
  name: 'SubPageSpine',
  component: () => import('@/views/courses/SubPageSpine.vue')
},

{
  path: '/sub-page/wzdh',
  name: 'SubPageWzdh',
  component: () => import('@/views/courses/SubPageTBH.vue')
},

{
  path: '/sub-page/ca',
  name: 'SubPageCa',
  component: () => import('@/views/courses/SubPageCharacterAnimator.vue')
},

{
  path: '/sub-page/mg',
  name: 'SubPageMg',
  component: () => import('@/views/courses/SubPageMG.vue')
},

{
  path: '/sub-page/szgg',
  name: 'SubPageSzgg',
  component: () => import('@/views/courses/SubPageSZGG.vue')
},

{
  path: '/sub-page/substance-painter',
  name: 'SubPageSubstancePainter',
  component: () => import('@/views/courses/SubPageSubstancePainter.vue')
},

{
  path: '/sub-page/dlxmn',
  name: 'SubPageDLXMN',
  component: () => import('@/views/courses/SubPageDLXMN.vue')
},

{
  path: '/sub-page/jsfzsj',
  name: 'SubPageJSFZSJ',
  component: () => import('@/views/courses/SubPageJSFZSJ.vue')
},

{
  path: '/sub-page/bqdhzz',
  name: 'SubPageBQDHZZ',
  component: () => import('@/views/courses/SubPageBQDHZZ.vue')
},

{
  path: '/sub-page/szdk',
  name: 'SubPageSZDK',
  component: () => import('@/views/courses/SubPageSZDK.vue')
},

{
  path: '/sub-page/xrjs',
  name: 'SubPageXRJS',
  component: () => import('@/views/courses/SubPageXRJS.vue')
},

{
  path: '/sub-page/yxyh',
  name: 'SubPageYXYH',
  component: () => import('@/views/courses/SubPageYXYH.vue')
},

{
  path: '/sub-page/yxmxbd',
  name: 'SubPageYXMXBD',
  component: () => import('@/views/courses/SubPageYXMXBD.vue')
},

{
  path: '/sub-page/yxtxzz',
  name: 'SubPageYXTXZZ',
  component: () => import('@/views/courses/SubPageYXTXZZ.vue')
},

{
  path: '/sub-page/yxjmsj',
  name: 'SubPageYXJMSJ',
  component: () => import('@/views/courses/SubPageYXJMSJ.vue')
},

{
  path: '/sub-page/yxdbzz',
  name: 'SubPageYXDBZZ',
  component: () => import('@/views/courses/SubPageYXDBZZ.vue')
},

{
  path: '/sub-page/yxkf',
  name: 'SubPageYXKF',
  component: () => import('@/views/courses/SubPageYXKF.vue')
},

//office.vue 中的流程路由
{
  path: '/workflows/tksq',
  name: 'TksqFlow',
  component: () => import('@/views/workflows/TksqFlow.vue')
},

{
  path: '/workflows/wcsq',
  name: 'WcsqFlow',
  component: () => import('@/views/workflows/WcsqFlow.vue')
},





]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫，确保需要认证的页面只有登录用户才能访问，并检查令牌是否过期
router.beforeEach((to, from, next) => {
  // 检查是否有令牌
  const token = localStorage.getItem('token')
  const isAuthenticated = !!token
  
  // 检查令牌是否过期
  const tokenExpiry = localStorage.getItem('tokenExpiresAt')
  const isTokenExpired = tokenExpiry ? Date.now() > parseInt(tokenExpiry) : true
  
  // 如果令牌过期，则登出用户
  if (isAuthenticated && isTokenExpired) {
    store.dispatch('logout')
    
    // 如果当前页面需要认证，则重定向到首页
    if (to.matched.some(record => record.meta.requiresAuth)) {
      next({ 
        path: '/',
        query: { redirect: to.fullPath, expired: 'true' }
      })
      return
    }
  }
  
  // 如果页面需要认证且用户未登录或令牌已过期，重定向到首页
  if (to.matched.some(record => record.meta.requiresAuth) && (!isAuthenticated || isTokenExpired)) {
    next({ 
      path: '/',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

export default router